export default "__VITE_ASSET__BPvuWw6v__"